import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';
import {
  ITrackingObject,
  ITrackingAction,
  I2gNgTrackingActionBuilder,
} from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../../../billing/src/paywall/paywall-data/tracking';
import { IOauthGoogleInfo } from '../../components/oauth-google-circle/oauth-google-circle.component';
import { IOauthFacebookInfo } from '../../components/oauth-facebook-circle/oauth-facebook-circle.component';
import { IOauthAppleInfo } from '../../components/oauth-apple-circle/oauth-apple-circle.component';

@Component({
  selector: 'app-customer-review-layout',
  templateUrl: './customer-review-layout.component.html',
  styleUrls: ['./customer-review-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerReviewLayoutComponent implements OnInit {
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() headerCtaLabel: string;
  @Input() headerCtaRoute: IRouter;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() errorMessage: string;

  @Output() facebookLoginSuccess = new EventEmitter<IOauthFacebookInfo>();
  @Output() googleLoginSuccess = new EventEmitter<IOauthGoogleInfo>();
  @Output() appleLoginSuccess = new EventEmitter<IOauthAppleInfo>();
  @Output() facebookLoginError = new EventEmitter<Error>();
  @Output() googleLoginError = new EventEmitter<Error>();
  @Output() appleLoginError = new EventEmitter<Error>();

  facebookTrackingAction: ITrackingAction;
  googleTrackingAction: ITrackingAction;
  appleTrackingAction: ITrackingAction;
  starIcon: IIcon;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnInit() {
    this.facebookTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'facebook_account',
      this.trackingScreenName
    );
    this.googleTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'google_account',
      this.trackingScreenName
    );
    this.appleTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'apple_account',
      this.trackingScreenName
    );

    this.starIcon = {
      name: 'star',
      size: IconSizesEnum.custom,
    };
  }
}
